import React from 'react'
import { user_check, user_x, child_icon_2 } from '../../../Shared/icons'
import CardSelector from '../../../Shared/CardSelector/CardSelector'

const BowlerMembershipChoices = [
    {
        id: "Yes",
        title: 'Yes',
        subTitle: 'This bowler is a current or previous USBC member',
        description: '',
        icon: user_check
    },
    {
        id: "No",
        title: 'No',
        subTitle: 'This bowler has never been a USBC member',
        description: '',
        icon: user_x
    },
];

function BowlerMembership(props) {

    function onBowlerMembershipChanged(e) {

        let selectedAction = e.target.value;

        let shouldCleanState = false;
        if (props.wizardState?.bowlerMembership !== selectedAction) {
            shouldCleanState = true;
        }

        props.updateWizardState((prev) => {
            let currentState = { ...prev };

            if (shouldCleanState === true) {
                delete currentState.memberId;
                delete currentState.bowlerProfile;
                delete currentState.isMemberFoundBySearch;
            }

            return {
                ...currentState,
                bowlerMembership: selectedAction
            };
        });
        
        props.nextView({
            bowlerMembership: selectedAction
        });
    }

    function BowlerMembershipContent() {
        var payload = BowlerMembershipChoices.map(choice => ({
            id: choice.id,
            title: choice.title,
            subTitle: choice.subTitle,
            description: choice.description,
            icon: choice.icon,
            checked: (props.wizardState?.bowlerMembership === choice.id)
        }));
        return <CardSelector list={payload} groupName="BowlerMembership" onCardSelected={onBowlerMembershipChanged} />;
    }

    return (
        <>
            <div className="row">
                <div className="col h4 wizard-step-title">
                    {props.step.title}
                </div>
            </div>
            <div className="row">
                {BowlerMembershipContent()}
            </div>
            <div className='wizard-buttons-container'>
                <button type="button" className="btn btn-primary bowl-btn" onClick={props.backView}>Back</button>
            </div>
        </>
    )
}

export default BowlerMembership